(function () {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    "[tabindex]:not([tabindex='-1'])",
  ].join(',');

  let activeModal = null;
  let scrollLockCount = 0;
  let previousBodyOverflow = '';

  const getFocusable = (element) =>
    Array.from(element.querySelectorAll(focusableSelector)).filter((node) => {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

  const lockScroll = () => {
    scrollLockCount += 1;
    if (scrollLockCount !== 1) return;
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.body.style.overflow = previousBodyOverflow;
  };

  function create(options) {
    const { panel, trigger, backdrop, modal = false, lockBodyScroll = modal, onOpen, onClose, initialFocus } = options || {};
    if (!panel) return null;

    let open = false;
    let returnFocus = null;

    const setHidden = (hidden) => {
      panel.hidden = hidden;
      panel.setAttribute('aria-hidden', String(hidden));
      backdrop?.toggleAttribute('hidden', hidden);
      backdrop?.setAttribute('aria-hidden', 'true');
    };

    const focusInitial = () => {
      const target = initialFocus?.() || getFocusable(panel)[0] || panel;
      target?.focus?.({ preventScroll: true });
    };

    const close = ({ restoreFocus = true } = {}) => {
      if (!open) return;
      open = false;
      setHidden(true);
      trigger?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('pointerdown', handlePointerDown, true);
      backdrop?.removeEventListener('click', handleBackdropClick);
      if (lockBodyScroll) {
        unlockScroll();
      }
      if (modal) {
        if (activeModal === api) activeModal = null;
      }
      onClose?.();
      if (restoreFocus) (returnFocus || trigger)?.focus?.({ preventScroll: true });
    };

    const show = () => {
      if (open) return;
      if (modal && activeModal && activeModal !== api) activeModal.close({ restoreFocus: false });
      open = true;
      returnFocus = document.activeElement;
      setHidden(false);
      trigger?.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', handleKeydown);
      document.addEventListener('pointerdown', handlePointerDown, true);
      backdrop?.addEventListener('click', handleBackdropClick);
      if (modal) {
        activeModal = api;
      }
      if (lockBodyScroll) {
        lockScroll();
      }
      if (modal) {
        requestAnimationFrame(focusInitial);
      }
      onOpen?.();
    };

    function handleBackdropClick() {
      close();
    }

    function handlePointerDown(event) {
      if (!open) return;
      if (panel.contains(event.target) || trigger?.contains(event.target) || backdrop?.contains(event.target)) return;
      close({ restoreFocus: false });
    }

    function handleKeydown(event) {
      if (!open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (!modal || event.key !== 'Tab') return;
      const focusable = getFocusable(panel);
      if (focusable.length === 0) {
        event.preventDefault();
        panel.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    const api = {
      open: show,
      close,
      toggle: () => (open ? close() : show()),
      isOpen: () => open,
    };

    setHidden(true);
    return api;
  }

  window.RotaOverlay = { create, getFocusable };
})();
